export default function formatRetainStrikeRanksDecisionMessage({ round, retain } = {}) {
  const roundNumber = Number(round)

  if (!Number.isFinite(roundNumber) || roundNumber <= 0) {
    return ''
  }

  return retain
    ? `Round ${roundNumber} - Retain Strike Ranks confirmed`
    : `Round ${roundNumber} - Retain Strike Ranks declined`
}
